import { GetStaticProps } from 'next';
import { useEffect } from 'react';
import { ClearInNavbar } from '../../components/Navbar/ClearNavbar';
import { b2cData } from '../../components/cms/layout/components/header';
import CleartaxinPage from '../../components/homepage/cleartaxin-page';
import { HOMEPAGE_META_DATA } from '../../components/homepage/constants';
import CustomNavbarCTA from '../../components/homepage/custom-navbar-cta';
import { Meta } from '../../layout/Meta';
import { FM_ACTIONS, returnNoProps } from '../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../utils/static-pages/utils';
import { handleTrack } from '../../utils/tracker';

const HomePage = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.parentCategory = 'homepage';
      handleTrack({
        label: window.location.pathname,
        action: FM_ACTIONS.pageview,
      });
    }
  }, []);
  const customRightCTA = <CustomNavbarCTA />;
  return (
    <>
      <ClearInNavbar
        data={b2cData}
        showPlanVariant={'variantA'}
        bgColor="bg-pink-brand"
        customRightCTA={customRightCTA}
      />
      <Meta
        title={HOMEPAGE_META_DATA.title}
        description={HOMEPAGE_META_DATA.description}
        canonical={HOMEPAGE_META_DATA.canonical}
        keywords={HOMEPAGE_META_DATA.keywords}
        isItr={HOMEPAGE_META_DATA.isItr}
        img={HOMEPAGE_META_DATA.img}
      />
      <CleartaxinPage />
    </>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  () => {
    return returnNoProps();
  }
);

export default HomePage;
